import { defineMessages } from 'react-intl.macro';
import { FormattedMessage } from 'react-intl';

import { Table } from '@tmapy/style-guide';

import type { NestedCheckResponse } from '../../openapi/types';

import { SSE_TYPE, useSSE } from '../../hooks';
import { CheckRecord } from './CheckRecord';

const msg = defineMessages({
  checkRecordState: {
    id: 'checkRecord.state',
    defaultMessage: 'Stav',
  },
  checkRecordLog: {
    id: 'checkRecord.log',
    defaultMessage: 'Log',
  },
  checkRecordChecker: {
    id: 'checkRecord.checker',
    defaultMessage: 'Provedl',
  },
  checkRecordCreated: {
    id: 'checkRecord.created',
    defaultMessage: 'Zahájeno',
  },
  checkRecordFinished: {
    id: 'checkRecord.finished',
    defaultMessage: 'Ukončeno',
  },
});

type CheckRecordListProps = {
  docId: number | undefined;
  items: NestedCheckResponse[];
  onClick: (id: number) => void;
  onRefetch: () => void;
};

export const CheckRecordList = ({ docId, items, onClick, onRefetch }: CheckRecordListProps) => {
  useSSE(SSE_TYPE.CHECKS);
  return (
    <Table isClickable>
      <thead>
        <tr>
          <th>
            <FormattedMessage {...msg.checkRecordState} />
          </th>
          <th>
            <FormattedMessage {...msg.checkRecordLog} />
          </th>
          <th>
            <FormattedMessage {...msg.checkRecordChecker} />
          </th>
          <th className='sg-a-ta-r'>
            <FormattedMessage {...msg.checkRecordCreated} />
          </th>
          <th className='sg-a-ta-r'>
            <FormattedMessage {...msg.checkRecordFinished} />
          </th>
          <th />
          <th />
        </tr>
      </thead>
      <tbody>
        {items.map((item) => (
          <CheckRecord
            {...item}
            key={item.id}
            docId={docId}
            onClick={onClick}
            onRefetch={onRefetch}
          />
        ))}
      </tbody>
    </Table>
  );
};
